import { clsx } from 'clsx'

import { Repository } from '@basehub/data/replicache/index'
import { PublicRepo } from '@basehub/data/replicache/mutators/_public-types'

import { READMEOverview__Editor, READMEOverview__Visitor } from './overview'
// import { READMEUseCases__Editor, READMEUseCases__Visitor } from './use-case'
// import {
//   READMEFrameworks__Editor,
//   READMEFrameworks__Visitor,
// } from './frameworks'
// import { READMETechStack__Editor, READMETechStack__Visitor } from './tech-stack'

export const READMEAdditionalInfo = ({
  repo,
  visitor,
}: {
  repo: Repository | PublicRepo
  visitor?: boolean
}) => {
  if (visitor) {
    if (!repo.readme?.additionalInfo) return null

    const hasOverviewFilled = repo.readme.additionalInfo.overview || false
    const hasOneFilled = false //Boolean(
    //   repo.readme.additionalInfo.useCase.length ||
    //     repo.readme.additionalInfo.framework.length ||
    //     repo.readme.additionalInfo.techStack.length
    // )

    return (
      <div
        className={clsx(
          'grid gap-x-9',
          hasOverviewFilled && !hasOneFilled && 'grid-cols-1',
          hasOverviewFilled && hasOneFilled && 'grid-cols-2'
        )}
      >
        <READMEOverview__Visitor
          overview={repo.readme.additionalInfo.overview ?? ''}
        />

        {/* <div
          className={clsx(
            !hasOverviewFilled
              ? 'grid grid-flow-col gap-x-8'
              : 'flex flex-col gap-y-5'
          )}
        >
          <READMEUseCases__Visitor
            useCases={repo.readme.additionalInfo.useCase}
          />
          <READMEFrameworks__Visitor
            frameworks={repo.readme.additionalInfo.framework}
          />
          <READMETechStack__Visitor
            techStack={repo.readme.additionalInfo.techStack}
          />
        </div> */}
      </div>
    )
  }

  return (
    <>
      <READMEOverview__Editor repo={repo} />
      {/* <READMEUseCases__Editor repo={repo} />
      <READMEFrameworks__Editor repo={repo} />
      <READMETechStack__Editor repo={repo} /> */}
    </>
  )
}
